<template>
  <div class="dictionary-base">
    <data-table ref="dataTable" :option="option">
      <template slot="headAction">
        <a-button
          type="primary"
          style="margin-left:5px"
          @click="doorLockConfi()"
          >门锁配置</a-button
        >
        <a-button type="primary" style="margin-left:5px" @click="fileDown"
          >下载模板</a-button
        >
        <upLoadImage
          style="margin-left:5px"
          v-model="backUrl"
          :imageUrl="false"
          listType="text"
          text="导入"
          mode="file"
          @update="fileImport"
        />
        <a-button
          type="primary"
          style="margin-left:5px"
          @click="editRoomStatus"
          v-if="user.Account == 'superadmin'"
          >修改房态</a-button
        >
      </template>
    </data-table>
    <a-modal
      centered
      title="门锁配置"
      :maskClosable="maskClosable"
      v-model="visible"
      @ok="handleOk"
      okText="确认"
      width="70%"
    >
      <div style="width:100%">
        <data-grid
          ref="dataGrid"
          :columns="columns"
          v-model="json.dataList"
          :params="params"
          style="height: 370px;overflow: hidden;overflow-y: auto;"
          bordered
        >
        </data-grid>
      </div>
    </a-modal>
    <a-modal
      title="提示"
      :visible="visibleTip"
      :footer="null"
      @cancel="visibleTip = false"
    >
      <p class="tip-info">
        房号信息填写有误，可以点击该链接<span class="file" @click="editFile">
          {{ docUrl }}</span
        >下载文档，根据文档提示修改后重新导入！
      </p>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import { DataGrid } from "@/components/dataGrid";
import upLoadImage from "@/components/tools/upLoadImage";
import { exportsDownLoad } from "@/utils/common";
import promptModal from "@/components/promptModal";
import { cache } from "@/utils/common";
export default {
  components: {
    DataTable,
    DataGrid,
    upLoadImage
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      extendData: "",
      visible: false,
      maskClosable: false,
      json: {
        dataList: []
      },
      params: {},
      columns: [
        {
          title: "房间编号",
          dataIndex: "No",
          width: "30%"
        },
        {
          title: "门锁锁号",
          width: "50%",
          edit: {
            type: "input"
          },
          dataIndex: "LockNo"
        }
      ],
      currentRoomNo: "",
      roomList: [],
      docUrl: "",
      backUrl: "",
      visibleTip: false,
      user: {}
    };
  },
  created() {
    const _this = this;
    this.user = cache.get("user");
    _this.RoomLockNoQueryList();
    //房号api数据集中填写
    _this.apiOptions = {
      api: "RoomNo_List",
      params: {},
      addApi: "RoomNo_Add",
      getApi: "RoomNo_Get",
      editApi: "RoomNo_Edit",
      delApi: "RoomNo_Del"
    };

    //形成表格表单
    _this.option = {
      //搜索框内容
      headSearch: {
        colnum: 2,
        content: [
          {
            label: "房间编号",
            name: "No"
          },
          {
            label: "房型名称",
            name: "RoomTypeId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "RoomType" },
            dataField: "Data.RoomType",
            valueField: "Id",
            onChange: _this.rece
          }
        ]
      },
      //弹出窗内容
      form: {
        title: "房号",
        width: 900,
        content: [
          {
            label: "房间编号",
            name: "No",
            props: {
              placeholder: "多个房间逗号隔开  如：1004,1005"
            }
          },
          {
            label: "房型名称",
            name: "RoomTypeId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "RoomType" },
            dataField: "Data.RoomType",
            valueField: "Id",
            option: {
              rules: [{ required: true }]
            },
            //房型下拉改变时执行额外操作
            onChange: _this.selectChange,
            load: data => {
              this.roomList = data;
            }
          },
          {
            label: "楼层",
            name: "FloorId",
            type: "select",
            api: "Common_GetSelect",
            param: { types: "Floor" },
            dataField: "Data.Floor",
            valueField: "Id"
          },
          {
            label: "可住人数",
            name: "AllowPersonCount",
            type: "number"
          },
          {
            label: "排序号",
            name: "Sort",
            type: "number" //计数器
          },
          {
            label: "状态",
            name: "RoomOtherStatus",
            type: "select",
            valueField: "value",
            textField: "text",
            data: [
              {
                value: 1,
                text: "启用"
              },
              {
                value: 0,
                text: "停用"
              }
            ]
          },
          {
            label: "备注",
            name: "Remark",
            colnum: 2,
            type: "textarea",
            option: {
              rules: [
                {
                  validator: (rule, value, callback) => {
                    if (value && value.length > 50) {
                      callback(new Error("不能超过50个字符!"));
                    } else {
                      callback();
                    }
                  }
                }
              ]
            }
          }
        ],
        //新增弹窗
        add: {
          submitApi: _this.apiOptions.addApi,
          onOpenAfter: () => {
            let values = { RoomOtherStatus: 1, Floor: 1, Sort: 0 };
            return values;
          },
          onSubmitBefore: values => {
            if (_this.extendData2 != "") {
              values.Type = _this.extendData;
              values.RoomTypeName = _this.extendData2;
            }
            return values;
          }
        },
        //编辑弹窗
        edit: {
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: values => {
            _this.extendData2 = values.RoomTypeName;
            _this.currentRoomNo = values.No;
            return values;
          },
          onSubmitBefore: values => {
            const result = this.roomList.find(el => el.Id == values.RoomTypeId);
            if (result) {
              _this.extendData2 = result.Text;
              values.Type = _this.extendData;
              values.RoomTypeName = _this.extendData2;
            }
            if (values.No != _this.currentRoomNo) {
              this.$warning({
                title:
                  "【修改房号】可能导致此房号之前生成的房态记录在房态图上无法展示"
              });
              return values;
            }
          }
        },
        del: {
          submitApi: _this.apiOptions.delApi,
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      //表格内容
      grid: {
        api: _this.apiOptions.api, //数据表格api
        props: {
          scroll: {
            x: 1200,
            y: "calc(100vh - 300px)"
          }
        },
        columns: [
          {
            title: "序号",
            width: 60,
            align: "center",
            type: "indexcolumn"
          },
          { title: "房间编号", width: 150, dataIndex: "No", align: "center" },
          {
            title: "房型名称",
            width: 200,
            dataIndex: "RoomTypeName",
            align: "center"
          },
          {
            title: "楼层",
            width: 100,
            dataIndex: "FloorName"
          },
          {
            title: "可住人数",
            width: 100,
            dataIndex: "AllowPersonCount",
            align: "center"
          },
          {
            title: "排序号",
            width: 80,
            dataIndex: "Sort",
            align: "center"
          },
          {
            title: "状态",
            width: 80,
            dataIndex: "OtherStatusName"
          },
          {
            title: "备注",
            dataIndex: "Remark",
            customRender: text => {
              return <div style="word-break: break-all;">{text}</div>;
            }
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "150px",
            key: "action",
            align: "center",
            fixed: "right",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    RoomLockNoQueryList() {
      this.$post("RoomLockNoQueryList").then(res => {
        this.json.dataList = res.Data;
      });
    },
    handleOk() {
      let json = this.json.dataList;
      this.$post("SetRoomLockNo", { RoomLockNoInfos: json }).then(() => {
        this.$message.success("配置门锁锁号成功");
      });
    },
    doorLockConfi() {
      this.visible = true;
      this.RoomLockNoQueryList();
    },
    selectChange(e, Data) {
      var _this = this;
      const formData = _this.$refs.dataTable.getFormData(true);

      _this.extendData2 = Data.Text;

      _this.$refs.dataTable.setFormData({
        ...formData,
        AllowPersonCount: Data.Data.AllowPersonCount
      });
    },
    //下载模板
    fileDown() {
      let url = this.$config.serverUrl + "" + "/api/RoomNo/FileDown";
      exportsDownLoad(url);
    },
    //导入
    fileImport() {
      const _this = this;
      this.$confirm({
        title: "确定导入吗?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          _this
            .$post(
              "RoomNo_FileImport",
              { Path: _this.backUrl },
              { alertError: false }
            )
            .then(res => {
              // this.$message.success("上传成功！");
              _this.$info({
                title: "提示",
                content: res.Data.Infos,
                onOk() {
                  _this.$refs.dataTable.headSearch();
                }
              });
            })
            .catch(err => {
              if (err.data.Code == "-1") {
                _this.visibleTip = true;
                _this.docUrl = err.data.Message;
              } else {
                const h = _this.$createElement;
                const arr = err.data.Message.split("\r\n").map(el => {
                  return h("p", el);
                });
                _this.$error({
                  title: "提示",
                  content: h("div", [arr])
                });
              }
            });
        },
        onCancel() {}
      });
    },
    editFile() {
      let url = this.$config.serverUrl + "/" + this.docUrl;
      exportsDownLoad(url);
    },
    editRoomStatus() {
      const row = this.$refs.dataTable.getSelected();
      if (!row) {
        this.$message.info("请选择房间");
        return false;
      }
      promptModal({
        title: "修改房态",
        type: "a-select",
        inputProps: {
          placeholder: "请选择房态",
          options: [
            { value: "0", label: "占用" },
            { value: "1", label: "空房" }
          ]
        },
        beforeSubmit: val => {
          return new Promise((resolve, reject) => {
            if (!val) {
              reject();
              this.$message.error("请选择修改房态");
              return false;
            }
            this.$post("ManualUpdateRoomStatus", {
              roomId: row.Id,
              roomStatus: val
            })
              .then(() => {
                resolve(true);
                this.handleSearch();
              })
              .catch(() => {
                reject();
              });
          });
        },
        submit: () => {
          return true;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tip-info {
  padding: 30px 20px 50px;
  font-size: 16px;
}
.file {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
